import { NgModule } from '@angular/core';

import { ComponentsModule } from './components/components.module';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';

const modules = [LayoutModule, ComponentsModule, PagesModule];

@NgModule({
  imports: modules,
  exports: modules,
})
export class CoreModule {}
